<template>
  <div class="form">
    <h4 v-show="!localData.id" class="mb-2">{{ $t("Keyword.New") }}</h4>
    <h4 v-show="localData.id" class="mb-2">{{ $t("Keyword.Edit") }}</h4>
    <dx-validation-group ref="validation-group">
      <div class="dx-fieldset">
        <div class="dx-field">
          <div class="dx-field-label">
            {{ this.$t("Keyword.Kind") }}
          </div>
          <div class="dx-field-value">
            <DxSelectBox
              :items="keywordKinds"
              :value.sync="localData.kind"
              display-expr="description"
              value-expr="id"
            />
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">
            {{ this.$t("Keyword.Value") }}
          </div>
          <div class="dx-field-value">
            <DxTextBox :value.sync="localData.value">
              <DxValidator>
                <DxRequiredRule :message="$t('Keyword.ValueRequired')" />
              </DxValidator>
            </DxTextBox>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label"></div>
          <div class="dx-field-value">
            <DxCheckBox
              :value.sync="localData.exactMatch"
              :text="$t('Keyword.ExactMatch')"
            />
          </div>
        </div>
      </div>
    </dx-validation-group>
    <div class="mt-6 text-right">
      <vs-button class="ml-4" @click="save">{{ this.$t("Ok") }}</vs-button>
      <vs-button class="ml-4" type="border" @click="cancel">{{
        $t("Cancel")
      }}</vs-button>
    </div>
  </div>
</template>


<script>
import DxSelectBox from 'devextreme-vue/select-box'
import DxButton from 'devextreme-vue/button'
import { DxTextBox } from 'devextreme-vue/text-box'
import { DxCheckBox } from 'devextreme-vue/check-box'
import DxValidationGroup from 'devextreme-vue/validation-group'
import DxValidationSummary from 'devextreme-vue/validation-summary'
import {
  DxValidator,
  DxRequiredRule,
  DxCompareRule,
  DxEmailRule,
  DxPatternRule,
  DxStringLengthRule,
  DxRangeRule,
  DxAsyncRule
} from 'devextreme-vue/validator'
export default {
  props: {
    value: Object
  },
  data () {
    return {
      localData: {},
      keywordKinds: []
    }
  },
  components: {
    DxButton,
    DxTextBox,
    DxCheckBox,
    DxSelectBox,
    DxValidationSummary,
    DxValidationGroup,
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxEmailRule,
    DxPatternRule,
    DxStringLengthRule,
    DxRangeRule,
    DxAsyncRule,
  },
  created () {
    console.log("Created KeywordEdit", this.value)
    this.localData = { ...this.value }
    const keywordKinds = ["Include", "Exclude"]
    this.keywordKinds = keywordKinds.map(a => {
      return { id: a, description: this.$t(`KeywordKind.${a}`) }
    })
  },
  methods: {
    save () {
      const validationGroup = this.$refs["validation-group"].instance
      const result = validationGroup.validate()
      if (!result.isValid) {
        return
      }
      this.$emit('saved', this.localData)
    },
    cancel () {
      this.$emit('closed')
    },
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
}
</script>

